import type { IdentifySubmitterToastCopy } from 'src/views/build/utils/identify-submitter-toast-copy';

declare const VueComponents: {
	BottomRightToast: {
		open: (props: Record<string, unknown>, events: Array<{ eventName: string; eventHandler: (...args: unknown[]) => void }>) => void;
		close: () => void;
	};
};
export type { IdentifySubmitterToastCopy };

/**
 * Show a simple success notification in bottom-right corner.
 */
export function showSuccessToast(message: string): void {
	VueComponents.BottomRightToast.open({
		title: message,
		showClose: true
	}, []);
}

export function dismissBottomRightToast(): void {
	if (typeof VueComponents !== 'undefined')
		VueComponents.BottomRightToast.close();
}

let _suppressWorkflowLinkAuthNotification = false;

export function suppressWorkflowLinkAuthNotification(): void {
	_suppressWorkflowLinkAuthNotification = true;
	setTimeout(() => { _suppressWorkflowLinkAuthNotification = false; }, 0);
}

export function isWorkflowLinkAuthNotificationSuppressed(): boolean {
	const val = _suppressWorkflowLinkAuthNotification;
	if (val) _suppressWorkflowLinkAuthNotification = false;
	return val;
}

export function showIdentifySubmitterAutoConfigToast(data: IdentifySubmitterToastCopy): void {
	VueComponents.BottomRightToast.open({
		title: 'Track Submissions by Person',
		identifySubmitterData: data,
		icon: 'identify-submitter',
		primaryAction: 'Got It',
		showClose: true,
		show: true,
		telemetryContext: 'identify-submitter'
	}, []);
}
